<template>
  <div
    v-if="!isEmpty || $ceres.isShopBuilder"
    class="widget-inner"
    :style="styleInner"
  >
    <div
      :class="classInner"
      :style="styleChildInner"
    >
      <ul :class="'list-style-' + listStyle + ' align-' + align">
        <template v-for="(entry, entryIndex) in entries">
          <template v-if="entry.entryType == 'text'">
            <li
              :key="entryIndex"
              class="text-type"
            >
              <i
                v-if="entry.icon != 'none'"
                class="fa"
                :class="[entry.iconClass]"
                aria-hidden="true"
              />
              <a
                v-if="entry.text.length > 0 && entry.urlVal && entry.urlVal.length > 0"
                :style="{ color: fontColor }"
                :target="entry.url.openInNewTab ? 'blank_' : false"
                :rel="entry.url.type ? 'noopener' : false"
                :href="entry.urlVal"
              >
                {{ entry.text }}
              </a>
              <span v-else>{{ entry.text }}</span>
            </li>
          </template>
          <template v-if="entry.entryType == 'vprop'">
            <li
              v-if="$ceres.isShopBuilder"
              :key="`entry-${entryIndex}`"
              class="vprop cast-preview"
            >
              <i
                v-if="entry.icon != 'none'"
                class="fa"
                :class="[entry.iconClass]"
                aria-hidden="true"
              />
              <span class="vprop-name">Eigenschaft ID</span>
              <span>{{ entry.variationPropertyId }}</span>
            </li>
            <template v-for="(point, pointIndex) in listPoints(entry.variationPropertyId)">
              <li
                :key="`point-${entryIndex}-${pointIndex}`"
                class="vprop"
                :class="'cast-'+point.cast"
              >
                <i
                  v-if="entry.iconClass != 'none'"
                  class="fa"
                  :class="entry.iconClass"
                  aria-hidden="true"
                />
                <span
                  v-if="entry.variationPropertyShowName && point.name && point.cast !== 'file'"
                  class="vprop-name"
                >{{ point.name }}</span>
                <a
                  v-if="point.cast === 'file'"
                  :href="point.value | propertyFileUrl"
                  :style="{ color: fontColor }"
                  target="_blank"
                  v-text="entry.variationPropertyShowName ? point.name : point.value"
                />
                <span
                  v-else-if="point.cast === 'html'"
                  v-html="point.value"
                />
                <span
                  v-else
                  v-text="point.value"
                />
              </li>
            </template>
          </template>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BulletPointsWidget',

  inject: {
    itemId: {
      default: null
    }
  },

  props: {
    styleInner: {
      type: String,
      default: ''
    },
    styleChildInner: {
      type: String,
      default: ''
    },
    classInner: {
      type: String,
      default: ''
    },
    listStyle: {
      type: String,
      default: ''
    },
    align: {
      type: String,
      default: ''
    },
    entriesList: {
      type: Array,
      default: () => []
    },
    fontColor: {
      type: String,
      default: '#000'
    }
  },

  computed: {
    currentVariation () {
      return this.$store.getters[`${this.itemId}/currentItemVariation`];
    },

    entries () {
      return this.entriesList.map((entry) => {
        const icon = (entry.icon === 'custom') ? entry.iconCustom : entry.icon;
        return { ...entry, iconClass: icon };
      });
    },

    isEmpty () {
      let isEmpty = true;
      for (const entry of this.entries) {
        if (entry.entryType == 'text' && entry.text.length > 0) {
          isEmpty = false;
        } else if (entry.entryType == 'vprop') {
          const property = this.getVariationPropertyById(entry.variationPropertyId);
          if (property) {
            let value = '';
            if (property.cast == 'multiSelection') {
              if (property.values && property.values.length > 0) {
                property.values.forEach((propVal) => {
                  value += propVal.value;
                });
              }
            } else {
              value += property.values.value;
            }

            if (value.length > 0) {
              isEmpty = false;
            }
          }
        }
      }
      return isEmpty;
    }
  },

  methods: {
    listPoints (variationPropertyId) {
      const property = this.getVariationPropertyById(variationPropertyId);

      if (!property) {
        return false;
      }

      const resultList = [];
      if (property.cast == 'multiSelection') {
        if (property.values && property.values.length > 0) {
          property.values.forEach((propVal) => {
            resultList.push({
              cast: property.cast,
              name: property.names.name,
              value: propVal.value
            });
          });
        }
      } else if (property.cast == 'file') {
        resultList.push({
          cast: property.cast,
          name: property.names.name,
          value: property.values.value
        });
      } else {
        resultList.push({
          cast: property.cast,
          name: property.names.name,
          value: property.values.value
        });
      }

      return resultList;
    },

    getVariationPropertyById (id) {
      let resultProperty = false;
      if (this.currentVariation && this.currentVariation.variationProperties && this.currentVariation.variationProperties.length > 0) {
        this.currentVariation.variationProperties.forEach((propertyGroup) => {
          if (propertyGroup.properties) {
            const property = propertyGroup.properties.find(prop => prop.id == id);
            if (property) {
              resultProperty = property;
            }
          }
        });
      }
      return resultProperty;
    }
  }
};
</script>
